import { slugs } from 'common/constants/inputTypes'
import structureTypes from 'common/constants/structureTypes'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import NewAgreement from 'publisher/components/entities/Agreement/Agreement'
import AudioNew from 'publisher/components/entities/AudioNew'
import BookingCalendar from 'publisher/components/entities/booking-calendar/index'
import OptInButtonNew from 'publisher/components/entities/button-new'
import Carousel from 'publisher/components/entities/Carousel'
import ContentTable from 'publisher/components/entities/ContentTable'
import Countdown from 'publisher/components/entities/Countdown'
import FacebookComments from 'publisher/components/entities/FacebookComments'
import Faq from 'publisher/components/entities/Faq'
import BaseFieldNew from 'publisher/components/entities/field-new/base-field'
import CountryFieldNew from 'publisher/components/entities/field-new/country-field'
import EmailFieldNew from 'publisher/components/entities/field-new/email-field'
import PhoneNumberFieldNew from 'publisher/components/entities/field-new/phone-number-field'
import Image from 'publisher/components/entities/Image'
import NewBulletList from 'publisher/components/entities/NewBulletList'
import NewHorizontalLine from 'publisher/components/entities/NewHorizontalLine'
import { PopupNew } from 'publisher/components/entities/popup-new'
import Section from 'publisher/components/entities/Section'
import SectionOld from 'publisher/components/entities/Section/SectionOld'
import SurveyNew from 'publisher/components/entities/Survey/SurveyNew'
import TextNew from 'publisher/components/entities/TextNew'
import TwitterTweetButton from 'publisher/components/entities/TwitterTweetButton'
import VideoNew from 'publisher/components/entities/Video'
import PriceElement from 'publisher/pages/sale-page/components/price-element'
import React from 'react'
import Checkbox from 'src/publisher/entities/checkbox/checkbox'
import { LoginButton } from 'src/publisher/entities/login-button'
import { Menu } from 'src/publisher/entities/menu'
import { RegistrationButton } from 'src/publisher/entities/registration-button'
import { WebsiteButton } from 'src/publisher/entities/website-button'
import { WebsiteFooter } from 'src/publisher/entities/website-footer'
import { WebsiteHeader } from 'src/publisher/entities/website-header'
import { WebsiteLanguageSwitcher } from 'src/publisher/entities/website-language-switcher'
import { WebsiteLayoutBody } from 'src/publisher/entities/website-layout-body'
import { WebsiteLogo } from 'src/publisher/entities/website-logo'
import { WebsitePageBody } from 'src/publisher/entities/website-page-body'
import Breadcrumbs from '../../components/entities/Breadcrumbs'
import Column from '../../components/entities/Column'
import ContentBox from '../../components/entities/ContentBox'
import Headline from '../../components/entities/Headline'
import NewLanguageSwitcher from '../../components/entities/NewLanguageSwitcher'
import NewRawHtml from '../../components/entities/NewRawHtml'
import OptInRecaptcha from '../../components/entities/OptInRecaptcha'
import Row from '../../components/entities/Row'
import Attachments from '../../pages/contact-us/components/Attachments'
import Recaptcha from '../../pages/contact-us/components/Recaptcha'
import TextArea from '../../pages/contact-us/components/TextArea'

export const createEntityElement = () => {
  return (entity: any, additionalProps = {}) => {
    const key = `entity-${entity.id}`
    switch (entity.type) {
      case EntityTypeEnum.WebsiteHeader:
        return <WebsiteHeader entity={entity} key={key} />
      case EntityTypeEnum.WebsiteFooter:
        return <WebsiteFooter entity={entity} key={key} />
      case EntityTypeEnum.WebsiteLayoutBody:
        return <WebsiteLayoutBody entity={entity} key={key} />
      case EntityTypeEnum.WebsitePageBody:
        return <WebsitePageBody entity={entity} key={key} />
      case structureTypes.SECTION:
        return <SectionOld entity={entity} key={key} />
      case EntityTypeEnum.Section:
        return <Section entity={entity} key={key} />
      case EntityTypeEnum.Row:
        return <Row entity={entity} key={key} />
      case EntityTypeEnum.Column:
        return <Column entity={entity} key={key} {...additionalProps} />
      case EntityTypeEnum.BulletList:
        return <NewBulletList entity={entity} key={key} />
      case EntityTypeEnum.BookingCalendar:
        return <BookingCalendar entity={entity} key={key} />
      case EntityTypeEnum.Button:
        return <OptInButtonNew entity={entity} key={key} />
      case EntityTypeEnum.WebsiteButton:
        return <WebsiteButton entity={entity} key={key} />
      case EntityTypeEnum.WebsiteLanguageSwitcher:
        return <WebsiteLanguageSwitcher entity={entity} key={key} />
      case EntityTypeEnum.LoginButton:
        return <LoginButton entity={entity} key={key} />
      case EntityTypeEnum.RegistrationButton:
        return <RegistrationButton entity={entity} key={key} />
      case EntityTypeEnum.Field:
        switch (entity.slug) {
          case slugs.EMAIL:
            return <EmailFieldNew entity={entity} />
          case slugs.COUNTRY:
            return <CountryFieldNew entity={entity} />
          case slugs.PHONE_NUMBER:
            return <PhoneNumberFieldNew entity={entity} />
          default:
            return <BaseFieldNew entity={entity} key={key} />
        }
      case EntityTypeEnum.ContentBox:
        return <ContentBox entity={entity} key={key} />
      case EntityTypeEnum.FacebookComments:
        return <FacebookComments entity={entity} key={key} />
      case EntityTypeEnum.RawHtml:
        return <NewRawHtml entity={entity} key={key} />
      case EntityTypeEnum.Checkbox:
        return <Checkbox entity={entity} key={key} />
      case EntityTypeEnum.Countdown:
        return <Countdown entity={entity} key={key} />
      case EntityTypeEnum.Menu:
        return <Menu entity={entity} key={key} />
      case EntityTypeEnum.WebsiteLogo:
        return <WebsiteLogo entity={entity} key={key} />
      case EntityTypeEnum.LanguageSwitcher:
        return <NewLanguageSwitcher entity={entity} key={key} />
      case EntityTypeEnum.HorizontalLine:
        return <NewHorizontalLine entity={entity} key={key} />
      case EntityTypeEnum.TwitterTweetButton:
        return <TwitterTweetButton entity={entity} key={key} />
      case EntityTypeEnum.Survey:
        return <SurveyNew entity={entity} key={key} />
      case EntityTypeEnum.Carousel:
        return <Carousel entity={entity} key={key} />
      case EntityTypeEnum.Faq:
        return <Faq entity={entity} key={key} />
      case EntityTypeEnum.PriceElement:
        return <PriceElement entity={entity} key={key} />
      case EntityTypeEnum.Text:
        return <TextNew entity={entity} key={key} />
      case EntityTypeEnum.Headline:
        return <Headline entity={entity} key={key} />
      case EntityTypeEnum.ContentTable:
        return <ContentTable entity={entity} key={key} />
      case EntityTypeEnum.Recaptcha:
        return <Recaptcha entity={entity} key={key} />
      case EntityTypeEnum.OptInRecaptcha:
        return <OptInRecaptcha entity={entity} key={key} />
      case EntityTypeEnum.TextArea:
        return <TextArea entity={entity} key={key} />
      case EntityTypeEnum.Breadcrumbs:
        return <Breadcrumbs entity={entity} key={key} />
      case EntityTypeEnum.Attachments:
        return <Attachments entity={entity} key={key} />
      case EntityTypeEnum.Video:
        return <VideoNew entity={entity} key={key} />
      case EntityTypeEnum.Image:
        return <Image entity={entity} key={key} />
      case EntityTypeEnum.Audio:
        return <AudioNew entity={entity} key={key} />
      case EntityTypeEnum.Agreement:
        return <NewAgreement entity={entity} key={key} />
      case EntityTypeEnum.Popup:
        return <PopupNew entity={entity} key={key} {...additionalProps} />
      default:
        return <div /> /* let's return empty div temporarily */
      // throw new Error(`unknown type ${entity.type} of node id = ${entity.id}`)
    }
  }
}
